import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { AuthService } from "../services/auth.service";

@Injectable({
  providedIn: "root",
})
export class UserRoleGuard  {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const role = this.auth.getSalesRole();
    const allowedPath = ["dashboard, plans", "coverage_area"];
    const currentPath = state.url.split("/")[1];
    if (role == "Channel Sales and Marketing") {
      if (allowedPath.includes(currentPath)) {
        return true;
      } else {
        return this.router.createUrlTree(["dashboard"]);
      }
    } else {
      return true;
    }
  }
}
